import React, { useEffect, useState } from "react";
import api from "../common/api";
import { IconButton, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import axios from "axios";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0.25rem",
          fontSize: "0.8rem",
          maxWidth: "10rem"
        }
      }
    }
  });

const SAPProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getProjects();
  }, []);

  const getProjects = async () => {
    let url = api.sapProjects().index();
    setLoading(true);

    const token = localStorage.getItem("userToken");
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProjects(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "code",
      label: "Código"
    },
    {
      name: "name",
      label: "Nombre"
    },
    {
      name: "description",
      label: "Descripción"
    },
    {
      name: "start_date",
      label: "Fecha de Inicio"
    },
    {
      name: "end_date",
      label: "Fecha de Fin"
    },
    {
      name: "client.business_name",
      label: "ID Cliente"
    }
  ];
  let options = {
    selectableRows: false,
    selectableRowsOnClick: false,
    customToolbar: () => {
      return (
        <Tooltip title={"Nuevo"}>
          <IconButton
            onClick={e => {
              window.location.href = "sap-project/0";
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      );
    },
    textLabels: {
      body: {
        noMatch: loading ? (
          <CircularProgress size={24} />
        ) : (
          "No hay datos disponibles"
        )
      }
    }
  };
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>
        <CircularProgress size={50} />
      </div>
    );
  }
  return (
    <div>
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title="Proyectos SAP"
          data={projects}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    </div>
  );
};

export default SAPProjects;
